const isDemoRoute = () => window.location.pathname.startsWith('/retrospective-demo')

export default isDemoRoute
